/**
 * Procedure Categories and Procedures for MD in General Medicine students
 * Extracted with strict evidence from official NMC PDF
 */
export const GENERAL_MEDICINE_PROCEDURES = {
  "Diagnostic Aspiration & Biopsy Procedures": [
    "Pleural Tap (Thoracentesis)",
    "Abdominal Paracentesis (Ascitic Tap)",
    "Lumbar Puncture",
    "Arterial Puncture for ABG Analysis",
    "Bone Marrow Aspiration and Trephine Biopsy",
    "Aspiration of Liver Abscess",
    "Joint Fluid Aspiration (Arthrocentesis)",
    "Percutaneous Liver Biopsy",
    "Percutaneous Kidney Biopsy",
    "Fine Needle Aspiration Cytology (FNAC) from Palpable Lumps",
    "Pericardiocentesis",
  ],
  "Critical Care & Emergency Procedures": [
    "Endotracheal Intubation",
    "Cardiopulmonary Resuscitation (CPR) & Defibrillation",
    "Central Venous Line Placement & CVP Monitoring",
    "Initiation of Non-Invasive & Mechanical Ventilation",
    "Hemodialysis Procedure",
  ],
};

export const GENERAL_MEDICINE_CATEGORIES = Object.keys(GENERAL_MEDICINE_PROCEDURES);

export const isMDInGeneralMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("general medicine") ||
    d.includes("internal medicine") ||
    (d.includes("medicine") &&
      !d.includes("community") &&
      !d.includes("family") &&
      !d.includes("forensic") &&
      !d.includes("aerospace") &&
      !d.includes("tropical") &&
      !d.includes("radiation") &&
      !d.includes("sports") &&
      !d.includes("geriatric") &&
      !d.includes("physical") &&
      !d.includes("palliative") &&
      !d.includes("emergency") &&
      !d.includes("nuclear") &&
      !d.includes("laboratory") &&
      !d.includes("marine") &&
      !d.includes("reproductive") &&
      !d.includes("transfusion") &&
      !d.includes("critical care") &&
      !d.includes("pulmonary") &&
      !d.includes("chest") &&
      !d.includes("respiratory"))
  );
};
